import React, { useEffect, useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import InView from 'react-intersection-observer'
import { animated, useSpring, useSpringRef, useChain } from 'react-spring'

import * as styles from './styles.module.scss'

const BlackFriday: React.FC = () => {
	const { t } = useTranslation()
	const [startAnimation, setStartAnimation] = useState(false)

	const pathAnimationRef = useSpringRef()
	const pathAnimationProps = useSpring({
		from: {
			strokeDasharray: 4000,
			strokeDashoffset: 4000
		},
		to: {
			strokeDasharray: 4000,
			strokeDashoffset: 0
		},
		config: { friction: 400 },
		delay: 1000,
		ref: pathAnimationRef
	})

	const bubbleSpring = {
		from: {
			transform: 'scale(0)'
		},
		to: {
			transform: 'scale(1)'
		},
		config: { mass: 1, tension: 400, friction: 30 }
	}

	const bubble2019Ref = useSpringRef()
	const bubble2019Props = useSpring({
		...bubbleSpring,
		ref: bubble2019Ref
	})

	const bubble2020Ref = useSpringRef()
	const bubble2020Props = useSpring({
		...bubbleSpring,
		ref: bubble2020Ref
	})

	const bubble2021Ref = useSpringRef()
	const bubble2021Props = useSpring({
		...bubbleSpring,
		ref: bubble2021Ref
	})

	useChain(
		startAnimation
			? [pathAnimationRef, bubble2019Ref, bubble2020Ref, bubble2021Ref]
			: [],
		[0, 1, 1.4, 2]
	)

	return (
		<section className={styles.section}>
			<svg
				width="1922"
				height="608"
				viewBox="0 0 1922 608"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={styles.lines}
			>
				<animated.path
					d="M1,399.63C39.4076,385.164 79.9465,373.628 121.477,374.848C194.483,376.993 213.74,441.133 215.854,449.505C237.161,533.849 282.833,438.55 401.369,381.594C478.379,348.435 551.898,341.645 619.333,372.842C651.33,387.644 682.692,404.273 713.653,422.193C760.287,446.758 906.493,564.008 963.378,472.752C1000.23,413.637 974.551,337.653 981.467,269.94C985.538,230.097 991.126,187.055 1021.23,157.957C1053.01,127.241 1105.02,120.558 1150.33,129.224C1195.65,137.891 1236.5,159.423 1277.84,178.432C1319.18,197.442 1363.6,214.523 1409.87,213.101C1475.75,211.077 1538.32,171.743 1603.17,182.511C1630.01,186.968 1655.01,199.899 1682.27,200.843C1720.94,202.183 1756.06,178.813 1779.34,150.609C1802.61,122.406 1817.15,89.1154 1836.9,58.7547C1856.65,28.3961 1883.93,11.1392 1921,1"
					stroke="#D52878"
					strokeWidth="1.4"
					strokeMiterlimit="10"
					{...pathAnimationProps}
				/>
				<animated.path
					opacity="0.8"
					d="M1921 11C1883.93 21.1392 1856.65 38.3961 1836.9 68.7547C1817.15 99.1154 1802.61 132.406 1779.34 160.609C1756.06 188.813 1720.94 212.183 1682.27 210.843C1655.01 209.899 1630.01 196.968 1603.17 192.511C1538.32 181.743 1475.75 221.077 1409.87 223.101C1363.6 224.523 1319.18 207.442 1277.84 188.432C1236.5 169.423 1195.65 147.891 1150.33 139.224C1105.02 130.558 1053.01 137.241 1021.23 167.957C991.126 197.055 985.538 240.097 981.467 279.94C974.551 347.653 1000.23 423.637 963.378 482.752C906.493 574.008 760.287 456.758 713.653 432.193C682.692 414.273 651.33 397.644 619.333 382.842C551.898 351.645 478.379 358.435 401.369 391.594C282.833 448.55 237.161 543.849 215.854 459.505C213.74 451.133 194.483 386.993 121.477 384.848C79.9465 383.628 39.4076 395.164 1 409.63"
					stroke="white"
					strokeWidth="1.4"
					strokeMiterlimit="10"
					{...pathAnimationProps}
				/>
				<animated.path
					opacity="0.6"
					d="M1921 21C1883.93 31.1392 1856.65 48.3961 1836.9 78.7547C1817.15 109.115 1802.61 142.406 1779.34 170.609C1756.06 198.813 1720.94 222.183 1682.27 220.843C1655.01 219.899 1630.01 206.968 1603.17 202.511C1538.32 191.743 1475.75 231.077 1409.87 233.101C1363.6 234.523 1319.18 217.442 1277.84 198.432C1236.5 179.423 1195.65 157.891 1150.33 149.224C1105.02 140.558 1053.01 147.241 1021.23 177.957C991.126 207.055 985.538 250.097 981.467 289.94C974.551 357.653 1000.23 433.637 963.378 492.752C906.493 584.008 760.287 466.758 713.653 442.193C682.692 424.273 651.33 407.644 619.333 392.842C551.898 361.645 478.379 368.435 401.369 401.594C282.833 458.55 237.161 553.849 215.854 469.505C213.74 461.133 194.483 396.993 121.477 394.848C79.9465 393.628 39.4076 405.164 1 419.63"
					stroke="white"
					strokeWidth="1.4"
					strokeMiterlimit="10"
					{...pathAnimationProps}
				/>
				{/* <animated.path
						d="M1 607C298.379 365.234 209.903 632.655 365.479 467.503C453.931 373.607 555.814 305.835 665.299 307.894C723.555 308.99 840.206 363.419 887.037 386.07C989.518 435.637 1023.19 535.486 1096.27 478.333C1150.87 435.637 1174.42 503.932 1198.9 529.108C1235.5 566.739 1312.31 403.853 1404.02 405.897C1499.33 408.021 1502.62 502.428 1613.71 346.623C1677.76 256.789 1753.42 166.009 1921 179.302"
						stroke="#D52878"
						strokeWidth="1.4"
						strokeMiterlimit="10"
						{...pathAnimationProps}
					/> */}
			</svg>

			<div className="container position-relative pt-5">
				<div className="row">
					<div className="col-lg py-4 text-center text-sm-start">
						<h2 className="display-2 text-white mb-3">Black Friday</h2>
						<InView onChange={(inView) => inView && setStartAnimation(true)}>
							<p className="text-white h6 mb-8 line-height-lg">
								{t('blackFriday.text')}
							</p>
						</InView>
					</div>
					<div className="col-lg">
						<div className="row gx-0">
							<div className="col-sm text-center text-sm-end order-1 order-sm-0">
								<animated.div
									className={`${styles.circle} ${styles.circle2020}`}
									style={bubble2020Props}
								>
									<strong className="h1 text-white mb-1">140 000</strong>
									<span className="h5 text-white mb-0">
										{t('blackFriday.year')} 2020
									</span>
								</animated.div>
							</div>
							<div className="col-sm text-center text-sm-start">
								<animated.div
									className={`${styles.circle} ${styles.circle2019}`}
									style={bubble2019Props}
								>
									<strong className="h1 text-white mb-1">100 000</strong>
									<span className="h5 text-white mb-0">
										{t('blackFriday.year')} 2019
									</span>
								</animated.div>
							</div>
						</div>
						<div className="text-center">
							<animated.div
								className={`${styles.circle} ${styles.circlePink}`}
								style={bubble2021Props}
							>
								<strong className="display-3 text-white mb-1">180 000</strong>
								<span className="h4 text-white mb-0">
									{t('blackFriday.year')} 2021
								</span>
							</animated.div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default BlackFriday
